<script lang="ts">
  import type { Action } from "svelte/action";
  import type { MenuParams } from "../dropdown-menu/create";
  import type { HTMLAttributes } from "svelte/elements";

  interface $$Props extends HTMLAttributes<HTMLUListElement> {
    action: Action<HTMLElement, MenuParams>;
    menuOptions?: MenuParams;
  }
  export let action: Action<HTMLElement, MenuParams>;
  export let menuOptions: MenuParams = {
    strategy: "absolute",
    placement: "bottom-end",
    closeOnClickOutside: true,
  };
</script>

<div class="menu" {...$$restProps} use:action={menuOptions}>
  <div class="content">
    <slot />
  </div>
</div>

<style>
  .menu {
    padding: 4px;
    min-width: var(--filter-menu-minW);
    max-width: var(--filter-menu-maxW, 320px);
    border-radius: var(--rk-rounding-s);
    border: 1px solid rgba(0, 0, 0, 0.1);
    background: var(--primary-light, #fff);
    box-shadow: 0px 8px 24px 0px rgba(31, 34, 38, 0.12), 0px 2px 9px 0px rgba(31, 34, 38, 0.06);
    z-index: 99;
  }

  .content {
    display: flex;
    flex-direction: column;
    max-height: var(--menu-maxH, 550px);
    overflow-y: auto;
  }
</style>
